import { Button, Empty } from 'antd';
import React from 'react';
import { useEnvironment } from './EnvironmentContext';

/** 未配置当前环境时的占位提示 */
const EnvironmentMissing: React.FC = () => {
  const { openPanel } = useEnvironment();
  return (
    <Empty
      description="尚未配置当前环境，请先在左下角环境面板中选择并配置 API Key。"
      style={{ padding: '48px 0' }}
    >
      <Button type="primary" onClick={openPanel}>
        前往环境配置
      </Button>
    </Empty>
  );
};

export default EnvironmentMissing;